export default __webpack_public_path__ + "static/media/yair-sharki.cf83fb82.png";